// need to add polymer element to be able register style modules
import { PolymerElement, html } from '@polymer/polymer';

import './hyp/reset.js';
import './hyp/color.js';
import './hyp/typography.js';
import './hyp/scaffolding.js';

const styleElement = document.createElement('dom-module');

styleElement.innerHTML =
`<template>
    <style include="com-theme-reset"></style>
    <style include="com-theme-scaffolding"></style>
    <style include="com-theme-typography"></style>
    <style include="com-theme-color"></style>
  </template>`;

styleElement.register('com-theme');